import { render, staticRenderFns } from "./NewslettersNew.vue?vue&type=template&id=57f5b296"
import script from "./NewslettersNew.vue?vue&type=script&lang=js"
export * from "./NewslettersNew.vue?vue&type=script&lang=js"
import style0 from "./NewslettersNew.vue?vue&type=style&index=0&id=57f5b296&prod&lang=scss&module=true"
import style1 from "./NewslettersNew.vue?vue&type=style&index=1&id=57f5b296&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports